import { render } from "./EditCustomEventAlert.vue?vue&type=template&id=6c76fe36"
import script from "./EditCustomEventAlert.vue?vue&type=script&lang=js"
export * from "./EditCustomEventAlert.vue?vue&type=script&lang=js"
script.render = render

export default script